/* src/app/admin/audit-log/audit-log-result/values/audit-response.component.scss */
.audit-response-table {
  margin-bottom: 30px;
}
/*# sourceMappingURL=audit-response.component-I7Q3ENJ5.css.map */
